import React, { Component, Fragment } from 'react';
import { API, Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import PropTypes from 'proptypes';
import { scroller, readableResponseMessage } from 'ux-helpers';
import { formatTripName } from './../../../helpers/TripHelper';

import Trip from './Trip';
import PortalHeader from './../../lib/portalHeader/PortalHeader';
import './TripList.scss';

import laosMapOff from './../../../../src/assets/tripIcons/laos-map-off.png';
import nepalMapOff from './../../../../src/assets/tripIcons/nepal-map-off.png';
import nicaraguaMapOff from './../../../../src/assets/tripIcons/nicaragua-map-off.png';
import tanzaniaMapOff from './../../../../src/assets/tripIcons/tanzania-map-off.png';
import thailandMapOff from './../../../../src/assets/tripIcons/thailand-map-off.png';
import wildMapOff from './../../../../src/assets/tripIcons/wild-map-off.png';
import worldMapOff from './../../../../src/assets/tripIcons/world-map-off.png';
import hawaiiMapOff from './../../../../src/assets/tripIcons/Hawaii-map-cutout-VP.png';
import coloradoUtahMapOff from './../../../../src/assets/tripIcons/colorado-utah-map-off.png';
import pnwMapOff from './../../../../src/assets/tripIcons/pnw-map-off.png';

import laosMapOn from './../../../../src/assets/tripIcons/laos-map-on.png';
import nepalMapOn from './../../../../src/assets/tripIcons/nepal-map-on.png';
import nicaraguaMapOn from './../../../../src/assets/tripIcons/nicaragua-map-on.png';
import tanzaniaMapOn from './../../../../src/assets/tripIcons/tanzania-map-on.png';
import thailandMapOn from './../../../../src/assets/tripIcons/thailand-map-on.png';
import wildMapOn from './../../../../src/assets/tripIcons/wild-map-on.png';
import worldMapOn from './../../../../src/assets/tripIcons/world-icon-VP.png';
import costaRicaMapOn from './../../../../src/assets/tripIcons/CR-map-cutout-VP.png';
import zanzibarMapOn from './../../../../src/assets/tripIcons/Zanzibar-map-cutout-VP.png';
import aroundTheWorldMapOn from './../../../../src/assets/tripIcons/AW-60-VP-Icon.png';
import kilimanjaroMapOn from './../../../../src/assets/tripIcons/kilimanjaro-on.png';
import privateGroupsMapOn from './../../../../src/assets/tripIcons/private-groups-on.png';

import AdditionalInformation from './../../lib/forms/AdditionalInformation';
import DataLayer from '../../../configuration/dataLayer';

const publicIp = require('public-ip');

const mapImages = {
  Nepal: {
    on: nepalMapOn,
    off: nepalMapOff,
  },
  'Volunteer Trips 40+': {
    on: worldMapOn,
    off: worldMapOff,
  },
  Tanzania: {
    on: tanzaniaMapOn,
    off: tanzaniaMapOff,
  },
  Thailand: {
    on: thailandMapOn,
    off: thailandMapOff,
  },
  Laos: {
    on: laosMapOn,
    off: laosMapOff,
  },
  Nicaragua: {
    on: nicaraguaMapOn,
    off: nicaraguaMapOff,
  },
  'WILD: Pacific Northwest': {
    on: wildMapOn,
    off: wildMapOff,
  },
  'USA: Hawaii': {
    on: hawaiiMapOff,
    off: hawaiiMapOff,
  },
  'USA: Colorado & Utah': {
    on: coloradoUtahMapOff,
    off: coloradoUtahMapOff,
  },
  'USA: Pacific Northwest': {
    on: pnwMapOff,
    off: pnwMapOff,
  },
  'Costa Rica': {
    on: costaRicaMapOn,
    off: costaRicaMapOn,
  },
  Zanzibar: {
    on: zanzibarMapOn,
    off: zanzibarMapOn,
  },
  'Around the World in 60 Days': {
    on: aroundTheWorldMapOn,
    off: aroundTheWorldMapOn,
  },
  'Zanzibar + Kilimanjaro Package': {
    on: kilimanjaroMapOn,
    off: kilimanjaroMapOn,
  },
  'Private Groups': {
    on: privateGroupsMapOn,
    off: privateGroupsMapOn,
  },
  default: {
    on: worldMapOn,
    off: worldMapOff,
  },
};

const classNames = ['first-choice', 'second-choice'];

class TripList extends Component {
  state = {
    cart: [],
    tripList: null,
    tabCount: 0,
    updateUser: false,
    loading: false,
    ip: '0.0.0.0',
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    });

    window.setTimeout(() => {
      publicIp
        .v4()
        .then(resp => {
          this.setState({
            ip: resp,
          });
        })
        .catch(error => {
          // IP Address Not Found
        });
    }, 1000);

    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          'Content-Type': 'application/json',
        },
      });
    });
    const options = { headers: this.state.headers };
    API.get('give-api', '/trips', options)
      .then(res => {
        if (res) {
          const tripsWithDates = res.filter(
            trip =>
              trip.name !== 'Private Groups' &&
              trip.name !== 'Past Volunteer Trips' &&
              trip.trips.length > 0
          );

          const privateGroups = res.filter(trip => trip.name === 'Private Groups');

          this.setState({
            tripList: [...tripsWithDates, ...privateGroups],
          });
        }
      })
      .catch(() => {});
  }

  returnMapImageUrl = (name, mapState) => {
    if (mapImages[name]) {
      return mapImages[name][mapState];
    } else {
      return mapImages['default'][mapState];
    }
  };

  hasRegisteredForTrip = tripId => {
    let trips = [];

    if (this.props.user && this.props.user.trips) {
      ({ trips } = this.props.user);
    }

    let hasAlreadyRegistered = false;

    for (let i = 0; i < trips.length; i += 1) {
      if (trips[i].tripDate === tripId) {
        hasAlreadyRegistered = true;
      }
    }
    return hasAlreadyRegistered;
  };

  addTrip = trip => {
    const { cart } = this.state;

    cart.push(trip);

    DataLayer.createEcommerceEvent('add_to_cart', [
      {
        item_id: trip.id,
        item_name: trip.name,
        item_category: 'Trip',
        quantity: 1,
      },
    ]);

    this.setState({
      cart,
    });
  };

  removeTrip = (e, toRemove) => {
    e.preventDefault();

    const cart = this.state.cart.filter(trip => trip.id !== toRemove.id);
    const trip = this.state.cart.filter(trip => trip.id === toRemove.id);

    if (cart.length) {
      document.getElementById(cart[0].id).className = 'first-choice';
    }

    DataLayer.createEcommerceEvent('remove_from_cart', [
      {
        item_id: trip.id,
        item_name: trip.name,
        item_category: 'Trip',
        quantity: 1,
      },
    ]);

    this.setState({
      cart,
    });
  };

  handleSelectingTrip = (e, trip) => {
    e.preventDefault();

    // TODO: Compare ID, not a split: cart[0].id.split("-")[1], or pass a different attribute.

    const { cart } = this.state;

    const { classList } = e.target;

    if (
      cart.length === 2 &&
      !classList.contains('first-choice') &&
      !classList.contains('second-choice')
    ) {
      this.setState({
        hasError: true,
      });

      if (this.state.hasError) {
        scroller('overflow-err');
      }
    } else {
      this.setState({
        hasError: false,
      });
    }

    if (cart.length < 1) {
      classList.add('first-choice');
      this.addTrip(trip);

      setTimeout(() => {
        scroller('submit-trip');
      }, 50);
    } else if (
      cart.length === 1 &&
      (classList.contains('first-choice') || classList.contains('second-choice'))
    ) {
      classList.remove(...classNames);
      this.removeTrip(e, trip);
      this.setState({
        hasError: false,
        alreadySelected: false,
      });
    } else if (cart.length === 1 && cart[0].id.split('-')[1] !== trip.id.split('-')[1]) {
      classList.add('second-choice');
      this.addTrip(trip);

      this.setState({
        alreadySelected: false,
      });

      setTimeout(() => {
        scroller('submit-trip');
      }, 50);
    } else if (cart.length === 1 && cart[0].id.split('-')[1] === trip.id.split('-')[1]) {
      this.setState({
        alreadySelected: true,
      });

      if (this.state.alreadySelected) {
        scroller('duplicate-err');
      }
    } else {
      classList.remove(...classNames);
      this.removeTrip(e, trip);
      this.setState({
        alreadySelected: false,
      });
    }
  };

  toggleActiveTrip = (e, id, index, name) => {
    e.stopPropagation();

    const target = document.getElementById(id);

    const activeImage = document.getElementById(`trip-img-${id}`);

    const activeTab = document.getElementById(`trip-tab-${id}`);

    if (!target.classList.contains('toggle')) {
      target.classList.add('toggle');
      activeTab.classList.add('active-trip-tab');
      activeImage.src = activeImage.src = this.returnMapImageUrl(name, 'on');

      this.setState({
        tabCount: this.state.tabCount + 1,
      });
    } else {
      target.classList.remove('toggle');
      activeTab.classList.remove('active-trip-tab');
      // activeImage.src = this.returnMapImageUrl(name, "off");

      this.setState({
        tabCount: this.state.tabCount - 1,
      });
    }

    if (id) {
      setTimeout(() => {
        scroller(`${id}-tag`);
      }, 50);
    }
  };

  submitAndUpdateUser = blnUpdateUser => {
    if (blnUpdateUser) {
      this.setState({
        updateUser: true,
      });
    }
    this.handleSubmit();
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    const { cart } = this.state;

    if (cart.length >= 1) {
      let alternateId;
      let alternateTripName;

      if (cart.length === 2) {
        ({ 1: alternateId } = cart[1].id.split('-'));
        alternateTripName = cart[1].name;
      }

      const {
        headers,
        cart: [{ id, name }],
      } = this.state;

      const options = {
        headers,
        body: {
          id: id.split('-')[1],
          name,
          alternateId,
          alternateTripName,
          firstName: this.props.user.firstName,
          lastName: this.props.user.lastName,
          ip: this.state.ip,
        },
      };
      // trip change request
      if (this.props.replaceOpportunityId !== '') {
        options.body.replaceOpportunityId = this.props.replaceOpportunityId;
        // Clear for next request
        this.props.setParentState('replaceOpportunityId', '');
      }

      this.setState({
        hasError: false,
        isProcessing: true,
      });

      API.post('give-api', '/user/trips', options)
        .then(
          () => {
            // If user attributes need updating, do that first, then route.
            if (this.state.updateUser) {
              let updateUserOptions = options;
              updateUserOptions.body = this.props.user;

              delete updateUserOptions.body['trips'];
              delete updateUserOptions.body['pastTrips'];

              // TODO: Only update values that have changed to speed up service call.

              API.post('give-api', '/user/', updateUserOptions)
                .then(
                  () => {
                    this.props.handleRouting();
                  },
                  () => {
                    this.setState({
                      isProcessing: false,
                      hasPostError: true,
                    });
                  }
                )
                .catch(error => {
                  this.setState({
                    message: readableResponseMessage(error),
                    isProcessing: false,
                  });
                });
            } else {
              this.props.handleRouting();
            }
          },
          () => {
            // TODO: proper error handling
            window.sessionStorage.removeItem('activeTab');
            this.setState({
              isProcessing: false,
              hasPostError: true,
            });
          }
        )
        .catch(error => {
          this.setState({
            message: readableResponseMessage(error),
            isProcessing: false,
          });
        });
    }
  };

  submitTrip = () => {
    this.handleSubmit();
  };

  render() {
    const { tripList, cart } = this.state;
    const {
      user,
      history: {
        location: { pathname },
      },
    } = this.props;

    let showChinesePassport = false;

    Object.keys(cart).forEach(function(key) {
      if (cart[key].name.includes('Nicaragua')) {
        showChinesePassport = true;
      }
    });

    return (
      <Fragment>
        {pathname === '/registration' ? (
          ''
        ) : (
          <PortalHeader setAppState={this.props.setAppState} user={user} title="Select a Trip" />
        )}
        {!tripList ? (
          <div className="row">
            <div className="col-md-12">
              <div className="loader throbber" style={{ bottom: '0' }} />
            </div>
          </div>
        ) : (
          <Fragment>
            <div className="tripList row">
              <div className="triplist-controls">
                {tripList.map((trip, i) => (
                  <div id="top-target" className="trip-tab" key={trip.id}>
                    <button
                      className="invisible"
                      id={`trip-tab-${trip.id}`}
                      onClick={e => {
                        this.toggleActiveTrip(e, trip.id, i, trip.name);
                      }}
                    >
                      <img
                        className="trip-icon"
                        id={`trip-img-${trip.id}`}
                        src={this.returnMapImageUrl(`${trip.name}`, 'on')}
                        alt={`${trip.name}`}
                      />
                    </button>
                    <h6 className="btn-text center">
                      <strong>
                        {trip.name === 'WILD: Pacific Northwest' ? 'WILD: PNW' : trip.name}
                      </strong>
                    </h6>
                  </div>
                ))}
              </div>
              <div className="trips-container">
                <div className="col-md-12">
                  <form
                    name="Trip List"
                    id="trip-list-form"
                    className="triplist-form"
                    ref={form => (this.form = form)}
                    onSubmit={e => this.handleSubmit(e)}
                  >
                    {tripList.map(trip => (
                      <Trip
                        key={trip.id}
                        id={trip.id}
                        name={trip.name}
                        content={trip.content}
                        approved={user !== undefined ? user.approved : false}
                        trips={trip.trips}
                        hasRegisteredForTrip={this.hasRegisteredForTrip}
                        onSelectingTrip={this.handleSelectingTrip}
                        cartIsEmpty={cart.length === 0}
                        pathname={pathname}
                      />
                    ))}
                    <div className="col-md-6 col-sm-12 center-margin" id="submit-trip">
                      {cart.length > 0 ? (
                        <div>
                          <strong className="center">
                            <h4 className="success">Your Trip!</h4>
                          </strong>
                          <div className="left">
                            <span className="round-icon small">1</span>{' '}
                            <h5 className="first">
                              {formatTripName(cart[0].name, cart[0].startDate, cart[0].endDate)}
                              <button
                                className="trash-can"
                                onClick={e => {
                                  document
                                    .getElementById(cart[0].id)
                                    .classList.remove('first-choice');
                                  this.removeTrip(e, cart[0]);
                                  this.setState({
                                    hasError: false,
                                  });
                                }}
                              />
                            </h5>
                          </div>
                          {cart.length < 2 ? (
                            <div>
                              <span className="round-icon small">2</span>{' '}
                              <h5
                                className="inline second cursor"
                                onClick={() => scroller('top-target')}
                              >
                                Optional: Select an Alternate Trip Above
                              </h5>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                      {cart.length === 2 ? (
                        <div className="left">
                          <span className="round-icon small">2</span>{' '}
                          <h5 className="second">
                            {formatTripName(cart[1].name, cart[1].startDate, cart[1].endDate)}
                            <button
                              className="trash-can"
                              onClick={e => {
                                document
                                  .getElementById(cart[1].id)
                                  .classList.remove('second-choice');
                                this.removeTrip(e, cart[1]);
                                this.setState({
                                  hasError: false,
                                });
                              }}
                            />
                          </h5>
                        </div>
                      ) : (
                        ''
                      )}
                      {this.state.hasError ? (
                        <p id="overflow-err" className="error">
                          You can only select two trips at a time. Please remove a trip.
                        </p>
                      ) : (
                        ''
                      )}
                      {this.state.alreadySelected ? (
                        <p id="duplicate-err" className="error">
                          This trip is already selected. Please select a different trip.
                        </p>
                      ) : (
                        ''
                      )}
                    </div>
                  </form>
                  {cart.length > 0 ? (
                    <div className="row">
                      <div className="col-md-6 col-sm-12 center-margin">
                        <span className="round-icon small">3</span>{' '}
                        <h5 className="second">Additional Information:</h5>
                        <AdditionalInformation
                          user={this.props.user}
                          setAppState={this.props.setAppState}
                          loading={this.state.isProcessing}
                          submitMessage="Almost there! Secure your spot and register for add-ons on the next screen!"
                          submitButtonText="Continue!"
                          callbackFunction={this.submitAndUpdateUser}
                          showChinesePassport={showChinesePassport}
                        />
                        {this.state.hasPostError ? (
                          <p className="error center">
                            Oops, something went wrong, please refresh this page and try again.
                          </p>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            {this.state.tabCount > 0 && cart.length < 1 ? (
              <div className="row">
                <div className="col-md-12">
                  <button onClick={() => scroller('top-target')} className="margin-center">
                    Back to top
                  </button>
                </div>
              </div>
            ) : (
              ''
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

TripList.propTypes = {
  setAppState: PropTypes.func,
  setParentState: PropTypes.func.isRequired,
  replaceOpportunityId: PropTypes.string,
  handleRouting: PropTypes.func,
};

TripList.defaultProps = {
  replaceOpportunityId: '',
};

export default withRouter(TripList);
